// src/components/AchievementSection.js

import React from "react";
import "./styles.css";
import useScrollReveal from "../../../../assets/hooks/useScrollReveal/useScrollReveal";
const achievementsData = [
  { icon: "🧑‍🤝‍🧑", stat: "3000+", title: "NHÂN VIÊN" },
  { icon: "🏗️", stat: "5000+", title: "DỰ ÁN HOÀN THÀNH" },
  { icon: "🤝", stat: "5000+", title: "ĐỐI TÁC LỚN" },
  { icon: "⭐", stat: "3000+", title: "ĐÁNH GIÁ TỐT TỪ KHÁCH HÀNG" },
];

const AchievementSection = () => {
  const getRevealClass = (isVisible) =>
    `service-card scroll-reveal-item ${isVisible ? "is-visible" : ""}`;
  return (
    <section className="achievement-section">
      <div className="achievement-section__content">
        {}
        <h3 className="achievement__subtitle">
          CÁC THÀNH TỰU HABAKO M&E ĐẠT ĐƯỢC
        </h3>

        {}
        <p className="achievement__title">
          HABAKO đã đạt được một số thành tựu nổi bật trong suốt 30 NĂM
        </p>

        {}
        <div className="achievement__stats-grid">
          {achievementsData.map((item, index) => {
            const [cardRef, isCardVisible] = useScrollReveal({
              threshold: 0.3,
            });
            return (
              <div
                key={index}
                className={`stat-card ${getRevealClass(isCardVisible)}`}
                ref={cardRef}
              >
                <div className="stat__icon">{item.icon}</div>
                <div className="stat__number">{item.stat}</div>
                <h4 className="stat__title">{item.title}</h4>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AchievementSection;
